var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGreenStar = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 199.68 199.92",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #91cc8b;\n        filter: url(#outer-glow-2);\n      }\n\n      .cls-2 {\n        fill: #4fb84e;\n        filter: url(#outer-glow-1);\n      }\n\n      .cls-3 {\n        fill: #31a649;\n        filter: url(#outer-glow-3);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2d78a",
    floodOpacity: 0.84
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2d78a",
    floodOpacity: 0.84
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "outer-glow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b2d78a",
    floodOpacity: 0.84
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.06,31.8l17.34,47.15c.24.66.77,1.18,1.43,1.43l47.15,17.34c2.1.77,2.1,3.74,0,4.52l-47.15,17.34c-.66.24-1.18.77-1.43,1.43l-17.34,47.15c-.77,2.1-3.74,2.1-4.52,0l-17.34-47.15c-.24-.66-.77-1.18-1.43-1.43l-47.15-17.34c-2.1-.77-2.1-3.74,0-4.52l47.15-17.34c.66-.24,1.18-.77,1.43-1.43l17.34-47.15c.77-2.1,3.74-2.1,4.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.8,100.39s-69.76.53-69.76-.41.53-1.87,1.58-2.26l47.15-17.34c.66-.24,1.18-.77,1.43-1.43l17.34-47.15c.39-1.05,1.32-1.58,2.26-1.58s0,70.17,0,70.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.8,99.57s69.76-.53,69.76.41-.53,1.87-1.58,2.26l-47.15,17.34c-.66.24-1.18.77-1.43,1.43l-17.34,47.15c-.39,1.05-1.32,1.58-2.26,1.58s0-70.17,0-70.17Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/greenStar.31d8fca0.svg";
export { ForwardRef as ReactComponent };